import React from "react"
import { Navigate, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import DocumentTemplatesPage from "../../../DocumentTemplates/DocumentTemplatesPage/DocumentTemplatesPage.tsx"
import { SettingsLayout } from "../../../Settings/components/common/SettingsLayout.tsx"
import SettingNotificationPage from "../../../Settings/pages/SettingNotificationPage.tsx"
import SettingsCompanyPage from "../../../Settings/pages/SettingsCompanyPage.tsx"
import SettingsProfilePage from "../../../Settings/pages/SettingsProfilePage.tsx"
import SettingsTemplatesPage from "../../../Settings/pages/SettingsTemplatesPage.tsx"
import DashboardTemplatesSettings from "../../../SettingsDashboardTemplates/DashboardTemplatesSettings.tsx"
import NewPermissionsSettings from "../../../SettingsPermissions/PermissionsSettings.tsx"
import ProjectTypePage from "../../../Templates/ProjectTypePage"
import ProjectTypesTemplatesPage from "../../../Templates/ProjectTypesTemplatesPage"
import { LegacyProjectTemplateRedirect } from "./LegacyTemplateRedirects.tsx"

export const settingsRoutes: RouteObject[] = [
  {
    path: RoutesPaths.settings.permissions,
    element: (
      <PermissionGate
        paths={["settings.permissions.settings_permissions_view"]}
      >
        <NewPermissionsSettings />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.settings.profile,
    element: <SettingsLayout />,
    children: [
      { index: true, element: <SettingsProfilePage /> },
      {
        path: RoutesPaths.settings.company,
        element: (
          <PermissionGate paths={["settings.company.settings_company_view"]}>
            <SettingsCompanyPage />
          </PermissionGate>
        )
      },
      {
        path: RoutesPaths.settings.templates,
        element: (
          <PermissionGate
            mode={"some"}
            paths={[
              "settings.project_templates.settings_template_view",
              "settings.document_templates.settings_proposal_template_view",
              "settings.permissions.settings_permissions_view"
            ]}
          >
            <SettingsTemplatesPage />
          </PermissionGate>
        )
      },
      {
        path: RoutesPaths.settings.projectTemplates,
        element: (
          <PermissionGate
            paths={["settings.project_templates.settings_template_view"]}
          >
            <ProjectTypesTemplatesPage />
          </PermissionGate>
        )
      },
      {
        path: RoutesPaths.settings.projectTemplate(":id"),
        element: (
          <PermissionGate
            paths={["settings.project_templates.settings_template_edit"]}
          >
            <ProjectTypePage />
          </PermissionGate>
        )
      },
      {
        path: RoutesPaths.settings.documentTemplates,
        element: (
          <PermissionGate
            paths={[
              "settings.document_templates.settings_proposal_template_view"
            ]}
          >
            <DocumentTemplatesPage />
          </PermissionGate>
        )
      },
      {
        path: RoutesPaths.settings.dashboardTemplates,
        element: (
          <PermissionGate
            paths={["settings.permissions.settings_permissions_view"]}
          >
            <DashboardTemplatesSettings />
          </PermissionGate>
        )
      },
      {
        path: "/settings/document_templates",
        element: (
          <Navigate replace to={RoutesPaths.settings.documentTemplates} />
        )
      },
      {
        path: "/settings/dashboard_templates",
        element: (
          <Navigate replace to={RoutesPaths.settings.dashboardTemplates} />
        )
      },
      {
        path: "/settings/templates/:id",
        element: <LegacyProjectTemplateRedirect />
      },
      {
        path: RoutesPaths.settings.notifications,
        element: <SettingNotificationPage />
      }
    ]
  }
]
